import { ChartType } from '../../types/prism';
import { isV2Migrated } from './core/utils';
export { V2_NAMESPACE_INDICATORS, CustomVisualPropsNamespaceKeys, CustomVisualPropsKeys, FontStyles, } from './core/constants';
export { isV2Migrated } from './core/utils';
export function areSettingsMigrated(visualProps) {
    return isV2Migrated(visualProps);
}
export function shouldMigrateSettings(visualProps, chartType, isChartSettingsV2Enabled) {
    if (!isChartSettingsV2Enabled) {
        return false;
    }
    if (typeof visualProps === 'string') {
        return false;
    }
    if (!visualProps || Object.keys(visualProps).length === 0) {
        return false;
    }
    if (chartType !== ChartType.AdvancedPivotTable) {
        return false;
    }
    if (isV2Migrated(visualProps)) {
        return false;
    }
    return true;
}
export async function migrateChartSettingsV1ToV2(visualProps, chartType) {
    const { migrateChartSettingsV1ToV2: migrate } = await import('./core/chart-settings-migrator');
    return migrate(visualProps, chartType);
}
//# sourceMappingURL=index.js.map